// TODO: for future improvement, try to use bookmaker_id instead of alias
import whitelabel1 from 'ClientsBranding/configs/marketRankingByClient/whitelabel1';
import supabets from 'ClientsBranding/configs/marketRankingByClient/supabets';
import coderespain from 'ClientsBranding/configs/marketRankingByClient/coderespain';
import betonalfa from 'ClientsBranding/configs/marketRankingByClient/betonalfa';
import opap from 'ClientsBranding/configs/marketRankingByClient/opap';
import opapsports from 'ClientsBranding/configs/marketRankingByClient/opapsports';
import luckiaes from 'ClientsBranding/configs/marketRankingByClient/luckiaes';
import grupoacrismatic from 'ClientsBranding/configs/marketRankingByClient/grupoacrismatic';
import kiroljokoa from 'ClientsBranding/configs/marketRankingByClient/kiroljokoa';
import bbetpoint from 'ClientsBranding/configs/marketRankingByClient/bbetpoint';
import caspiantechuof from 'ClientsBranding/configs/marketRankingByClient/caspiantechuof';
import boviktest from 'ClientsBranding/configs/marketRankingByClient/boviktest';
import olybet from 'ClientsBranding/configs/marketRankingByClient/olybet';
import meridian from 'ClientsBranding/configs/marketRankingByClient/meridian';

const clientMarketRankingsUOF = {
  whitelabel1,
  supabets,
  coderespain,
  betonalfa,
  opap,
  opapsports,
  luckiaes,
  grupoacrismatic,
  kiroljokoa,
  bbetpoint,
  caspiantechuof,
  boviktest,
  olybet,
  meridian,
};

export default clientMarketRankingsUOF;
